export const engagementReportBuilder2Result = "/engagement/report_builder_2/:report_id/:app_group_id/result";
